import React, { FC } from 'react';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { N300 } from '@atlaskit/theme/colors';

export const PaypalPaymentMethodLegalNote: FC = () => {
  return (
    <div className="legalSection">
      <div className="iconContainer">
        <InfoIcon label="" size="small" primaryColor={N300} />
      </div>
      <p className="legalNote">
        Atlassian will use this as the default payment method for future payments on this account. You can edit this
        later, or remove it by contacting support.
      </p>
    </div>
  );
};
